import React from 'react';
// @ts-ignore
import * as d3 from 'd3';
import styled from 'styled-components';

import { MARGIN } from './LineChart';

const BorderLine = styled.path`
  stroke: #ffffff;
  stroke-width: 4px;
  fill: none;
`;

interface Props {
  chartWidth: number,
  chartHeight: number,
}

const BorderBox = ({ chartWidth, chartHeight }: Props) => {
  const boxPoints: [number, number][] = [
    [MARGIN.left, MARGIN.top],
    [MARGIN.left, MARGIN.top + chartHeight],
    [MARGIN.left + chartWidth, MARGIN.top + chartHeight],
    [MARGIN.left + chartWidth, MARGIN.top],
  ];

  const line = d3.line()
    .x(d => d[0])
    .y(d => d[1]);

  const path = line(boxPoints);

  return <BorderLine d={path || ''} />;
};

export default BorderBox;
